var _excluded = ["children", "borderRadius"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import styled from "styled-components";
import forwardRef from "../../private/forwardRef";
import { paletteHelper } from "../../utils";
var Box = styled.div.withConfig({
  displayName: "Card__Box",
  componentId: "sc-3mecgt-0"
})(["box-shadow:", ";border-radius:", ";background-color:", ";"], _ref => {
  var {
    theme
  } = _ref;
  return theme.shadow;
}, _ref2 => {
  var {
    theme,
    $borderRadius
  } = _ref2;
  return theme.border.radius[$borderRadius];
}, paletteHelper("backgroundPrimaryLow"));

/**
 * The card component helps divide information into sections and to create visual hierarchy between elements.
 *
 * @see [Card documentation](https://construct-kit.reainternal.net/components/web/core/card)
 */
var Card = forwardRef((_ref3, ref) => {
  var {
      children,
      borderRadius = "large"
    } = _ref3,
    props = _objectWithoutPropertiesLoose(_ref3, _excluded);
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    $borderRadius: borderRadius
  }, props), children);
});
Card.displayName = "Card";
export default Card;